/**
 * 简单的事件总线实现
 * 用于在应用间进行登录状态通信
 */

type EventCallback = (data: any) => void;

class EventBus {
  private events: Map<string, Set<EventCallback>> = new Map();

  /**
   * 订阅事件
   * @param event 事件名称
   * @param callback 回调函数
   * @returns 取消订阅的函数
   */
  on(event: string, callback: EventCallback) {
    if (!this.events.has(event)) {
      this.events.set(event, new Set());
    }
    this.events.get(event)!.add(callback);

    // 返回取消订阅函数
    return () => this.events.get(event)?.delete(callback);
  }

  /**
   * 发布事件
   * @param event 事件名称
   * @param data 事件数据
   */
  emit(event: string, data?: any) {
    this.events.get(event)?.forEach((callback) => {
      try {
        callback(data);
      } catch (error) {
        console.error(`Error in event listener for ${event}:`, error);
      }
    });
  }

  /**
   * 取消所有订阅
   * @param event 事件名称，如果不提供则清除所有事件
   */
  off(event?: string) {
    if (event) {
      this.events.delete(event);
    } else {
      this.events.clear();
    }
  }
}

// 全局事件总线实例
export const eventBus = new EventBus();

// 登录相关事件常量
export const LOGIN_EVENTS = {
  LOGIN_SUCCESS: "login:success",
  LOGOUT: "login:logout"
} as const;

export type LoginEventData = {
  token: string;
  userInfo: any;
};
